var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges, OnInit, SimpleChanges, AfterViewInit } from '@angular/core';
import { Listing } from '../../classes/listing';
import { HasSubscriptions } from '../has-subscriptions';
import { SCREEN_SIZE, SortBy } from '../../classes/enums';
import { Pagination } from '../../classes/pagination';
import { Helper } from '../../classes/helper';
import { merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { INFINITE_SCROLL } from '../../classes/analytics-tags';
/**
 * We try to design the gallery so that its in as many ways as possible, just a component that worries about its own view, and doesn't worry about
 * data retrieval and other functions that don't exist solely for this component
 *
 * Items are passed in via the parent, and the logic that decided which elements to show are also decided by the parent
 */
var BaseGalleryViewComponent = /** @class */ (function (_super) {
    __extends(BaseGalleryViewComponent, _super);
    function BaseGalleryViewComponent(_preferencesService, _communicationService, _translate, _fb, _listingsService, _prerenderService, _analyticsService) {
        var _this = _super.call(this) || this;
        _this._preferencesService = _preferencesService;
        _this._communicationService = _communicationService;
        _this._translate = _translate;
        _this._fb = _fb;
        _this._listingsService = _listingsService;
        _this._prerenderService = _prerenderService;
        _this._analyticsService = _analyticsService;
        _this.totalResultsFound = 0;
        // TODO: fix this - See if there's a better way to do sorting options that changes depending on the type of the items
        _this.sortOptions = [
            {
                key: 'gallery.sortby.newest',
                value: SortBy.NEWEST
            },
            {
                key: 'gallery.sortby.oldest',
                value: SortBy.OLDEST
            },
        ];
        // TODO: whats the difference here
        _this.hasMoreResultsToLoad = true;
        _this.shouldHideSorting = false;
        _this.isFetchingItems = true;
        _this.pagination = new Pagination();
        _this.items = []; // TODO: Obsolete
        _this.itemClicked = new EventEmitter();
        _this.infiniteScrolled = new EventEmitter();
        _this.changePage = new EventEmitter();
        // Enums
        _this.Listing = Listing;
        _this.sortForm = _this._fb.group({
            sort: SortBy.NEWEST
        });
        _this.sortForm.controls['sort'].setValue(_this._preferencesService.getGallerySorting());
        return _this;
    }
    BaseGalleryViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this._communicationService.screenSize.subscribe(function (s) { return _this._screenSize = s; }));
    };
    BaseGalleryViewComponent.prototype.ngOnChanges = function (changes) { };
    BaseGalleryViewComponent.prototype.sortItems = function () { };
    BaseGalleryViewComponent.prototype.onGalleryScrolled = function () {
        // Only emit the infinite scroll for mobile since we use pagination for all greater sizes
        if (this._screenSize === SCREEN_SIZE.MOBILE_ONLY)
            this.infiniteScrolled.emit();
    };
    return BaseGalleryViewComponent;
}(HasSubscriptions));
export { BaseGalleryViewComponent };
var ListingGalleryViewComponent = /** @class */ (function (_super) {
    __extends(ListingGalleryViewComponent, _super);
    function ListingGalleryViewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleListingGallery = false;
        _this.isFavouritesPage = false; // Whether we're looking at the favourites gallery page
        _this.selectedClusterListings = []; // The first listing to show should be the listings that are part of the cluster they selected if any, can also be favourites
        _this.confirmUnfavourite = false; // Whether we need to show a confirm message when they're unfavouriting an item
        // TODO: migrate this to follow more the base
        _this.isDoneFetchingAllItems = true;
        _this.sortOptions = [
            {
                key: 'gallery.sortby.newest',
                value: SortBy.NEWEST
            },
            {
                key: 'gallery.sortby.oldest',
                value: SortBy.OLDEST
            },
            {
                key: 'gallery.sortby.priceLowToHigh',
                value: SortBy.PRICE_LOW_TO_HIGH
            },
            {
                key: 'gallery.sortby.priceHighToLow',
                value: SortBy.PRICE_HIGH_TO_LOW
            }
        ];
        _this.selectedClusterListingPairs = []; // A mapping of the selected cluster listings to their IDs
        return _this;
    }
    ListingGalleryViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.addSub(this.sortForm.valueChanges.pipe(debounceTime(200)).subscribe(function (value) {
            _this._preferencesService.setGallerySorting(value.sort);
            if (_this.selectedClusterListings && _this.selectedClusterListings.length)
                _this.sortSelectedClusterListings();
        }));
        this.addSub(this._communicationService.screenSize.subscribe(function (s) { return _this._screenSize = s; }));
        this.addSub(this._preferencesService.positionInfoChanged.subscribe(function (positionInfo) { return _this._positionInfo = positionInfo; }));
    };
    ListingGalleryViewComponent.prototype.ngOnChanges = function (changes) {
        // In mobile, this component is always displayed so when first initialized there won't be a location to use, we use this below to ensure that
        // some listings will display when we go to this gallery mode
        if (changes.toggleListingGallery && this.toggleListingGallery) {
            this.getMoreListings();
        }
        // If the selected listings change, we manually sort this ourselves, since we don't make a call to the server to get the selected listings sorted
        if (changes.selectedClusterListings && changes.selectedClusterListings.currentValue.length) {
            this.selectedClusterListingPairs = (this.selectedClusterListings || []).map(function (l) { return ({ listingId: l.listingId, detailUrl: l.detailUrl }); });
            // TODO: Sort this.primaryListings in memory using sort criteria
            this.sortSelectedClusterListings();
        }
    };
    ListingGalleryViewComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Make sure to reset the page number to get the listings to fetch properly and listings
        // TODO: should this be generalized and go into the base
        this.addSub(merge(this._communicationService.searchParametersChanged, this.sortForm.controls['sort'].valueChanges, this._communicationService.listings.currentShownListingType)
            .pipe(debounceTime(400))
            .subscribe(function () {
            // TODO: go up a level
            _this.pagination.pageNumber = 0;
            _this.hasMoreResultsToLoad = true;
            _this.items = [];
            _this.getMoreListings();
        }));
    };
    ListingGalleryViewComponent.prototype.onInfiniteScroll = function () {
        this._analyticsService.eventTrack(INFINITE_SCROLL, null);
    };
    /**
     * Whether or not we get more listings. If it's favourites, we don't paginate that so there's no need to get more listings
     */
    ListingGalleryViewComponent.prototype.getMoreListings = function () {
        if (this.isFavouritesPage || this._prerenderService.isServerMode)
            return;
        if (this.hasMoreResultsToLoad)
            this.getItems();
    };
    /**
     * Sort the selected cluster listings. We need to do this manually since these listings aren't coming sorted from the server via a service call, but instead from the map
     */
    ListingGalleryViewComponent.prototype.sortSelectedClusterListings = function () {
        var val = this.sortForm.get('sort').value;
        // TODO: should this go into the Listing class instead
        this.selectedClusterListings.sort(function (o1, o2) { return Listing.sortByMixed(o1, o2, val); });
    };
    /**
     * Makes calls to retrieve more listings
     */
    // TODO: should this be dealt with by the parent
    ListingGalleryViewComponent.prototype.getItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, newPage, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isDoneFetchingAllItems = false;
                        _b.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 6];
                        response = void 0;
                        if (!(!this._positionInfo || (this._positionInfo && !this._positionInfo.east && !this._positionInfo.west && !this._positionInfo.north && !this._positionInfo.south))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._listingsService.searchProvinceCity(this.province, this.city, this.pagination).toPromise()];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._listingsService.searchListingsGallery(this.pagination, this.sortForm.get('sort').value, true)];
                    case 4:
                        response = _b.sent();
                        _b.label = 5;
                    case 5:
                        if (response === null || response.results === null || response.results.length === 0)
                            this.hasMoreResultsToLoad = false;
                        else {
                            if (response.office) {
                                this.relatedOffice = response.office;
                                this.relatedOffice.telephone = Helper.formatPhoneNumber(this.relatedOffice.telephone);
                            }
                            this.pagination.setTotalResults(response.totalHits);
                            this.totalResultsFound = response.totalHits;
                            newPage = response.results.filter(function (l) { return _this.selectedClusterListingPairs.map(function (cl) { return cl.listingId; }).indexOf(l.listingId) < 0; });
                            this.pagination.pageNumber++;
                            // If the all the listings from the new page are duplicates, get new listings
                            if (!newPage || newPage.length === 0)
                                return [3 /*break*/, 1];
                            (_a = this.items).push.apply(_a, newPage);
                        }
                        return [3 /*break*/, 6];
                    case 6:
                        this.isDoneFetchingAllItems = true;
                        // TODO: dont use instant here
                        this._communicationService.notifications.notificationChanged.next(this._translate.instant('notification.n-listings-found', { n: this.totalResultsFound }));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * When they click on a listing card, we need to include the next listings that they can page through on the LDP
     * @param listing
     */
    ListingGalleryViewComponent.prototype.onGalleryCardClicked = function (listing) {
        // Combine all the listings together first
        var listings = this.selectedClusterListingPairs.concat(this.items.map(function (l) { return ({ listingId: l.listingId, detailUrl: l.detailUrl }); }));
        var offset = listings.findIndex(function (l) { return l.listingId === listing.listingId; });
        this._preferencesService.addNextListings(listings.map(function (l) { return ({ listingId: l.listingId, detailUrl: l.detailUrl }); }).slice(offset, listings.length));
        this.itemClicked.emit(listing);
    };
    return ListingGalleryViewComponent;
}(BaseGalleryViewComponent));
export { ListingGalleryViewComponent };
var GalleryViewComponent = /** @class */ (function (_super) {
    __extends(GalleryViewComponent, _super);
    function GalleryViewComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GalleryViewComponent;
}(BaseGalleryViewComponent));
export { GalleryViewComponent };
